module.exports = __webpack_public_path__ + "static/media/facebook-alpha.482d229d.png";